// Centralized booking status constants

// All cancelled-like terminal statuses
export const CANCELLED_STATUSES = [
  'CANCELLED - NON SERVICEABLE',
  'CANCELLED - MECHANIC DENIED',
  'CANCELLED - MECHANIC NOT AVAILABLE',
  'CANCELLED - CUSTOMER DID NOT RESPOND',
  'CANCELLED - CUSTOMER DENIED',
  'CANCELLED - EXPENSIVE',
  'CANCELLED - RSA',
  'CANCELLED - RAIN',
  'CANCELLED - ENQUIRY',
  'CANCELLED - SPARES NOT AVAILABLE',
  'CANCELLED - EV VEHICLE',
  'CANCELLED - AFTER HOURS',
  'CANCELLED - OTHER REASONS',
];

// Terminal statuses beyond which no action is needed in UI
export const TERMINAL_STATUSES = [
  'COMPLETED',
  'CASH TAKEN',
  'SETTLED',
  'DUPLICATE',
  ...CANCELLED_STATUSES,
];

// In-progress statuses valid to close modals without confirmation etc.
export const IN_PROGRESS_STATUSES = [
  'IN PROGRESS',
  'IN PROGRESS - AUTO',
  'IN PROGRESS - VEHICLE TOWED',
  'IN PROGRESS - BATTERY TOWED',
];


